import { isAndroid, isIos } from "react-device-detect";
import { SetHistory } from "../redux/actions";
import store from "../redux/store";
import moment from "moment-jalali";

const Constants = {
  baseUrl: "https://api.1inch.exchange/v3.0/",
  baseUrl2: "https://limit-orders.1inch.exchange/v1.0/",
  dateFormat: "YYYY-MM-DD",
  datetimeFormat: "YYYY-MM-DD HH:mm",
  expireToken: 7,
  siteUrl: "https://arix.exchange/",
};

const Patterns = {
  username: /^[A-Za-z0-9]([A-Za-z0-9_]{1,48})[A-Za-z0-9_]$/,
  mobile: /^(09)[0-9]{9}$/,
};

const handleSendSms = (smsBody, selectedDevice) => {
  const sound = new Audio("/assets/smsSended.mp3");
  //Save
  let oldHistory = store.getState().site.history;
  if (!!oldHistory.length) {
    if (oldHistory.length > 10) {
      oldHistory.shift();
    }
    store.dispatch(
      SetHistory([
        ...oldHistory,
        {
          text: smsBody,
          device: selectedDevice,
          date: moment().locale("fa").format("jYYYY/jM/jD HH:mm"),
        },
      ])
    );
  } else {
    store.dispatch(
      SetHistory([
        {
          text: smsBody,
          device: selectedDevice,
          date: moment().locale("fa").format("jYYYY/jM/jD HH:mm"),
        },
      ])
    );
  }

  var a = document.createElement("a");
  a.setAttribute(
    "href",
    `sms:+98${selectedDevice}${detectDevice()}body=${smsBody}`
  );
  sound.play();
  a.click();
};
const WalletAddressSimplefy = (Address) => {
  let newAddress;
  newAddress = Address.split("")
    .filter((x, i) => i < 10)
    .join("");
  return newAddress + " ...";
};

const detectDevice = () => {
  if (isAndroid) {
    return "?";
  } else if (isIos) {
    return "&";
  } else {
    return "&";
  }
};

const ArrayMove = (arr, old_index, new_index) => {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
};

export {
  Constants,
  Patterns,
  WalletAddressSimplefy,
  ArrayMove,
  handleSendSms,
  detectDevice,
};
